// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.headerLink{
  width: 100%;
}

.headerLink a {
  display: flex;
  color: #6c757d;
  align-items: center;
  text-decoration: none;
  cursor: pointer;
}

.headerLink a:hover,
.headerLink a:active,
.headerLink a:focus {
  font-weight: 600;
  text-decoration: none;
}

.headerLink > a {
  position: relative;
  padding: 0 10px;
  line-height: 45px;
  justify-content: space-between;
  text-decoration: none;
  color: #accbc3;
}

.headerLink > a:hover {
  background-color: rgba(172, 203, 195, 0.08);
  text-decoration: none !important;
  font-weight: 600 !important
}

.headerLink > a img {
  width: 15px;
  margin-right: 15px;
}

.arrow {
  color: #adb5bd;
  transition: 0.3s;
  right: 0;
}

.arrowActive {
  transform: rotate(-90deg);
}

.headerLinkActive span {
  color: #dc3545;
  font-weight: 600;
}

.panel {
  border: none;
  box-shadow: none;
  margin: 0;
  border-radius: 0;
  background: transparent;
}

.panel div {
  padding: 0;
}

.panel ul {
  font-size: 0.875rem;
}

.panel ul li {
  padding: 3px 0;
  list-style: none;
}

.panel ul a {
  padding: 4px 4px 4px 20px;
}

.panel ul a:hover,
.panel ul a:active,
.panel ul a:focus {
  font-weight: 600;
}

/* Child link styling to match sidebar design */
.sidebar-child-link {
  padding-left: 40px !important;
  font-size: 0.875rem;
  margin: 0 6px;
  display: flex;
  align-items: center;
  border-radius: 8px;
  text-decoration: none;
  font-weight: 500;
  transition: background-color 0.2s ease, color 0.2s ease;
  color: #accbc3;
  padding: 8px 14px 8px 40px !important;
}

.sidebar-child-link .sidebar-icon {
  font-size: 0.95rem;
  color: #accbc3;
  transition: color 0.2s ease;
  flex-shrink: 0;
}

.sidebar-child-link:hover {
  background-color: rgba(172, 203, 195, 0.08);
  color: #accbc3;
  text-decoration: none;
}

.sidebar-child-link:hover .sidebar-icon {
  color: #accbc3;
}

.sidebar-child-link.active {
  background-color: rgba(172, 203, 195, 0.22);
  color: #e8f0ee;
  font-weight: 600;
  border-left: 3px solid #1f7c50;
  padding-left: 37px !important;
}

.sidebar-child-link.active .sidebar-icon {
  color: #e8f0ee;
}

/* Keep active child link color when hovering */
.sidebar-child-link.active:hover {
  background-color: rgba(172, 203, 195, 0.22);
  color: #e8f0ee;
  text-decoration: none;
}

.sidebar-child-link.active:hover .sidebar-icon {
  color: #e8f0ee;
}

.sidebar-link.justify-content-center {
  justify-content: center;
}

.sidebar-link .arrow {
  margin-left: auto;
  color: #accbc3;
  transition: transform 0.2s ease;
  font-size: 0.875rem;
}

.sidebar-link .arrow.arrowActive {
  transform: rotate(-90deg);
}
`, "",{"version":3,"sources":["webpack://./src/components/Sidebar/LinksGroup/LinksGroup.css"],"names":[],"mappings":"AAAA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,cAAc;EACd,mBAAmB;EACnB,qBAAqB;EACrB,eAAe;AACjB;;AAEA;;;EAGE,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,8BAA8B;EAC9B,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EAEE,2CAA2C;EAC3C,gCAAgC;EAChC;AACF;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,QAAQ;AACV;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,SAAS;EACT,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;;EAGE,gBAAgB;AAClB;;AAEA,+CAA+C;AAC/C;EACE,6BAA6B;EAC7B,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,qBAAqB;EACrB,gBAAgB;EAChB,uDAAuD;EACvD,cAAc;EACd,qCAAqC;AACvC;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;EACE,2CAA2C;EAC3C,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,2CAA2C;EAC3C,cAAc;EACd,gBAAgB;EAChB,8BAA8B;EAC9B,6BAA6B;AAC/B;;AAEA;EACE,cAAc;AAChB;;AAEA,+CAA+C;AAC/C;EACE,2CAA2C;EAC3C,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":[".headerLink{\r\n  width: 100%;\r\n}\r\n\r\n.headerLink a {\r\n  display: flex;\r\n  color: #6c757d;\r\n  align-items: center;\r\n  text-decoration: none;\r\n  cursor: pointer;\r\n}\r\n\r\n.headerLink a:hover,\r\n.headerLink a:active,\r\n.headerLink a:focus {\r\n  font-weight: 600;\r\n  text-decoration: none;\r\n}\r\n\r\n.headerLink > a {\r\n  position: relative;\r\n  padding: 0 10px;\r\n  line-height: 45px;\r\n  justify-content: space-between;\r\n  text-decoration: none;\r\n  color: #accbc3;\r\n}\r\n\r\n.headerLink > a:hover {\r\n  font-weight: 300;\r\n  background-color: rgba(172, 203, 195, 0.08);\r\n  text-decoration: none !important;\r\n  font-weight: 600 !important\r\n}\r\n\r\n.headerLink > a img {\r\n  width: 15px;\r\n  margin-right: 15px;\r\n}\r\n\r\n.arrow {\r\n  color: #adb5bd;\r\n  transition: 0.3s;\r\n  right: 0;\r\n}\r\n\r\n.arrowActive {\r\n  transform: rotate(-90deg);\r\n}\r\n\r\n.headerLinkActive span {\r\n  color: #dc3545;\r\n  font-weight: 600;\r\n}\r\n\r\n.panel {\r\n  border: none;\r\n  box-shadow: none;\r\n  margin: 0;\r\n  border-radius: 0;\r\n  background: transparent;\r\n}\r\n\r\n.panel div {\r\n  padding: 0;\r\n}\r\n\r\n.panel ul {\r\n  font-size: 0.875rem;\r\n}\r\n\r\n.panel ul li {\r\n  padding: 3px 0;\r\n  list-style: none;\r\n}\r\n\r\n.panel ul a {\r\n  padding: 4px 4px 4px 20px;\r\n}\r\n\r\n.panel ul a:hover,\r\n.panel ul a:active,\r\n.panel ul a:focus {\r\n  font-weight: 600;\r\n}\r\n\r\n/* Child link styling to match sidebar design */\r\n.sidebar-child-link {\r\n  padding-left: 40px !important;\r\n  font-size: 0.875rem;\r\n  margin: 0 6px;\r\n  display: flex;\r\n  align-items: center;\r\n  border-radius: 8px;\r\n  text-decoration: none;\r\n  font-weight: 500;\r\n  transition: background-color 0.2s ease, color 0.2s ease;\r\n  color: #accbc3;\r\n  padding: 8px 14px 8px 40px !important;\r\n}\r\n\r\n.sidebar-child-link .sidebar-icon {\r\n  font-size: 0.95rem;\r\n  color: #accbc3;\r\n  transition: color 0.2s ease;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.sidebar-child-link:hover {\r\n  background-color: rgba(172, 203, 195, 0.08);\r\n  color: #accbc3;\r\n  text-decoration: none;\r\n}\r\n\r\n.sidebar-child-link:hover .sidebar-icon {\r\n  color: #accbc3;\r\n}\r\n\r\n.sidebar-child-link.active {\r\n  background-color: rgba(172, 203, 195, 0.22);\r\n  color: #e8f0ee;\r\n  font-weight: 600;\r\n  border-left: 3px solid #1f7c50;\r\n  padding-left: 37px !important;\r\n}\r\n\r\n.sidebar-child-link.active .sidebar-icon {\r\n  color: #e8f0ee;\r\n}\r\n\r\n/* Keep active child link color when hovering */\r\n.sidebar-child-link.active:hover {\r\n  background-color: rgba(172, 203, 195, 0.22);\r\n  color: #e8f0ee;\r\n  text-decoration: none;\r\n}\r\n\r\n.sidebar-child-link.active:hover .sidebar-icon {\r\n  color: #e8f0ee;\r\n}\r\n\r\n.sidebar-link.justify-content-center {\r\n  justify-content: center;\r\n}\r\n\r\n.sidebar-link .arrow {\r\n  margin-left: auto;\r\n  color: #accbc3;\r\n  transition: transform 0.2s ease;\r\n  font-size: 0.875rem;\r\n}\r\n\r\n.sidebar-link .arrow.arrowActive {\r\n  transform: rotate(-90deg);\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
